import { Component } from '@angular/core';
import { INoRowsOverlayAngularComp } from 'ag-grid-angular';

@Component({ standalone: false,
  selector: 'irb-custom-norow-overlay',
  templateUrl: './custom-norow-overlay.component.html',
  styleUrls: ['./custom-norow-overlay.component.scss']
})
export class CustomNoRowOverlayComponent implements INoRowsOverlayAngularComp {

  params: any;
  showClearFilters: boolean = false;

  constructor() { }

  agInit(params: any): void {
    this.params = params;
    if (this.params && this.params.parentObject) {
      this.showClearFilters = this.params.parentObject.showClearFilters;
    }
  }

  clearAllFilters() {
    if (this.params.parentObject) {
      this.params.api.deselectAll();

      this.params.parentObject['selectedOrDeSelectedRecords'] = [];
      this.params.parentObject['isSelectedAll'] = false;
      this.params.parentObject['headerCheckBoxState'] = 'unchecked';
      if (this.params.parentObject.clearAllFilters) {
        this.params.parentObject.clearAllFilters();
      } else {
        this.params.api.setFilterModel(null);
        this.params.api.refreshToolPanel();
      }
      if (this.params.parentObject.enableDisableBtns) {
        this.params.parentObject.enableDisableBtns();
      }
      this.showClearFilters = false;
    }
  }
}
